import * as yup from 'yup';
import { Typography } from 'app/components/ui';
import { i18n } from 'app/utils/i18n';
import { useUpdateTag } from 'app/api/tag-queries';
import { EditableNumberInput } from './EditableNumberInput';

const scaleSchema = yup.object().shape({
  scale: yup
    .number()
    .integer(i18n('tag.scale.mustBeInteger'))
    .min(0, i18n('tag.scale.mustBeNonNegative'))
    .nullable()
    .transform((_value, original) => (original === '' ? null : Number(original))),
});

interface ScaleFieldProps {
  tagId: string;
  documentSuperId: number;
  currentScale: number | null;
  disabled?: boolean;
}

export const ScaleField = ({ tagId, documentSuperId, currentScale, disabled = false }: ScaleFieldProps) => {
  const { mutate: updateTag } = useUpdateTag();

  const handleSubmit = (value: number | null) => {
    if (value === null) return;
    updateTag({ id: tagId, documentSuperId, scale: value });
  };

  return (
    <div className="property-row">
      <Typography fontWeight="semibold" className="property-label">
        {i18n('tag.scale.title')}
      </Typography>
      {disabled ? (
        <Typography variant="body-7" fontWeight="light">
          {currentScale ?? '-'}
        </Typography>
      ) : (
        <EditableNumberInput value={currentScale} onSubmit={handleSubmit} validationSchema={scaleSchema} fieldName="scale" placeholder="-" />
      )}
    </div>
  );
};
